import { FC } from 'react';
import { Link } from 'react-router-dom';

import { TemplateBadge } from 'entities/application/ui/TemplateBadge/TemplateBadge';
import {
	AppCardDescriptionStyled,
	AppCardImgStyled,
	AppCardNameStyled,
	AppCardStyled,
	AppCardTextContainerStyled,
	BadgeContainerStyled,
} from './AppCard.styles';

interface Props {
	id: string;
	name: string;
	description: string;
	logoUrl: string;
	isTemplate?: boolean;
}

export const AppCard: FC<Props> = ({ id, name, description, logoUrl, isTemplate }) => (
	<Link to={`/templates/${id}`}>
		<AppCardStyled>
			<AppCardImgStyled src={logoUrl} />
			<AppCardTextContainerStyled>
				<AppCardNameStyled>
					<span style={{ marginRight: `8px` }}>{name}</span>
					<BadgeContainerStyled>{isTemplate && <TemplateBadge />}</BadgeContainerStyled>
				</AppCardNameStyled>
				<AppCardDescriptionStyled>{description}</AppCardDescriptionStyled>
			</AppCardTextContainerStyled>
		</AppCardStyled>
	</Link>
);
